export default __webpack_public_path__ + "static/media/Achievement-bro.91c9327f.svg";